// extracted by mini-css-extract-plugin
export default {"-large":"q4IjU3XP7LTRoVmATXgv","headerContent":"vvSO0n81jXZaeuuv2VHK","mergeTagToggleOpen":"n3mHu6hHD4TN7d3kVt1N","deleteIcon":"KqkvOaWGq56MMMMvhcQf"};